import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { LogErrors } from './../../../../utilities/LogErrors'
//import { useLanguage } from './../../../../utilities/LanguageContext'

import { GetDataFromTheChosenCourse } from './../../../../utilities/BL/Student/Results'
import { SaveResultCourseToShow } from './../../../../utilities/BL/Navigation'


//Agregar multiidioma


const Result = ({ session, result }) => {
    //const { translate } = useLanguage() // Obtén la función de traducción desde el contexto
    const navigate = useNavigate()

    const [resultName, setResultName] = useState(null)
    
    const GoToCourseResults = async (_result) => {
        try {
            //Guardar el curso del que se van a mostrar los resultados
            const response = await SaveResultCourseToShow(session, _result.idCourse)
            
            if (response.success) {
                navigate('/results')
            } else {
                console.log(response.message)
            }
        } catch (error) {
            await LogErrors('GoToCourseResults Result', error)
        }
    }

    const LoadPage = async () => {
        try {
            // Obtener el nombre del curso
            const response = await GetDataFromTheChosenCourse(session, result.idCourse)

            if (response.success) {
                let courseName = ''
                let courseLevel = ''
                let courseType = ''

                if (response.data.level === 1) {
                    courseLevel = 'nivel 1'
                } else {
                    courseLevel = 'nivel 2'
                }

                if (response.data.type === 1) {
                    courseType = 'certificación'
                } else {
                    courseType = 'diplomado'
                }

                courseName = `${response?.data?.name ? response.data.name : ''} ${courseLevel} ${courseType}`

                setResultName(courseName)
                //setExamName(result.name)
            } else {
                // if (response.message !== undefined) {
                //     if (response.message !== '') {
                //         console.log(response.message)
                //     }
                // }

                console.log(response?.message)
            }
        } catch (error) {
            await LogErrors('LoadPage - Result', error) 
        }
    }

    /**
     * Función para obtener la configuración, una vez que termine de cargarse el componente
     */
    useEffect(() => {
        LoadPage()
    }, []) // El array vacío [] asegura que useEffect se ejecute solo una vez, al montar


    return (
        <div className='Dashboard--V2__Sections__List__Items--Ztudent Dashboard--V2__Sections__List__Items--Blue' onClick={() => GoToCourseResults(result)}>
            <p className='Dashboard--V2__Sections__List__Items--Ztudent__Subtitle'><i className='bi bi-file-earmark-bar-graph'></i> Resultado</p>
            <p className='Dashboard--V2__Sections__List__Items--Ztudent__Title'>{resultName}</p>

            <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Ztudent__Buttons' onClick={() => GoToCourseResults(result)}>
                <i className='bi bi-arrow-right'></i>
            </button>
        </div>
    )
}

export { Result };